import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import localityField from './localityField';
import { Input } from '../../util/controls';
import { poBox } from '../../util/validations';

let addressAdd = props => {
    const { handleSubmit, pristine, submitting, localities, getLocalities, clearLocalities } = props;
    
    return (
        <div>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="alert alert-warning text-center" role="alert">
                                We cannot deliver to PO Box or RMB addresses.
                            </div>
                            <div className="form-group">
                                <label className="control-label" htmlFor="name">Contact</label>
                                <Field className="form-control" name="contact" component="input" type="text" />
                            </div>
                            <div className="form-group">
                                <label className="control-label" htmlFor="address">Address Line 1</label>
                                <Field className="form-control" name="address" component={Input} validate={[poBox]} type="text" />
                            </div>
                            <div className="form-group">
                                <label className="control-label" htmlFor="address2">Address Line 2</label>
                                <Field className="form-control" name="address2" component={Input} validate={[poBox]} type="text" />
                            </div>
                            <Field
                                name="locality"
                                component={localityField}
                                type="text"
                                label="City/Postcode"
                                placeholder="Enter a city or postcode"
                                inputClassName="form-control"
                                onSuggestionsFetch={getLocalities}
                                onSuggestionsClear={clearLocalities}
                                suggestions={localities}
                                validate={[value => (value ? undefined : 'This field is required!')]} />
                        </div>
                    </div>
                </div>

                <button type="submit" disabled={pristine || submitting} className="btn btn-client btn-lg btn-block">Submit</button>
                <button type="button" className="btn btn-client-alt btn-lg btn-block" onClick={props.onCancel}>Cancel</button>
            </form>
        </div>
    );

};


addressAdd = reduxForm({
    form: 'addressAdd'
})(addressAdd);

addressAdd = connect(
    (state, ownProps) => ({
        initialValues: ownProps.address
    })

)(addressAdd);


export default addressAdd;




// WEBPACK FOOTER //
// ./app/address/components/addressAdd.js